import useHostAdminPage from "../composables/useHostAdminPage"

export default function useAdminView() {
  return useHostAdminPage()
}
